import API from '../../../../../services/api';
import { headers } from '../helpers/functionalities';

export const API_INCIDENCIAS = {
    getIncidencias: async (page = null, search = null) => {
        const pagination = page !== null ? '?page=' + page : '';
        const searcher = search !== null && page !== null ? '&' + search : search !== null ? '?' + search : '';
        return await API.get('/incidencias' + pagination + searcher).then(res => res.data);
    },
    getIncidencia: async (incidenciaId) => {
        return API.get('/incidencias/' + incidenciaId).then(res => res.data);
    },
    newIncidencia: async (incidencia) => {
        return API.post('/incidencias', incidencia).then(res => res.data);
    },
    cambiarSubestado: async (incidencia) => {
        return API.post('/incidencias/' + incidencia.id + '/subestado', incidencia).then(res => res.data);
    },
    cambiarResponsable: async (incidencia) => {
        return API.post('/incidencias/' + incidencia.id + '/responsable', incidencia).then(res => res.data);
    },
    marcarComoFinalizada: async (incidenciaId) => {
        return API.post('/incidencias/' + incidenciaId + '/finalizada', {}).then(res => res.data);
    },
    marcarComoActiva: async (incidenciaId) => {
        return API.post('/incidencias/' + incidenciaId + '/activa', {}).then(res => res.data);
    },
    marcarComoFinanzas: async (incidenciaId) => {
        return API.post('/incidencias/' + incidenciaId + '/finanzas', {}).then(res => res.data);
    },
    uploadDocuments: async (incidenciaId, documentos) => {
        return API.post('/incidencias/' + incidenciaId + '/upload_documentation', documentos, headers).then(res => res.data);
    },
    deleteIncidenciaFile: async (incidenciaId, documento) => {
        return API.post('/incidencias/' + incidenciaId + '/delete_documentation', documento).then(res => res.data);
    },
    getIncidenciaFiles: async (incidenciaId, documentacion) => {
        return API.post('/incidencias/' + incidenciaId + '/files', { documentacion }).then(res => res.data);
    },
    downloadFile: async (incidenciaId, documento) => {
        return API.post('/incidencias/' + incidenciaId + '/download', documento, {responseType: 'blob'}).then(res => res.data);
    },
    exportPerdidas: async (filters) => {
        return API.post('/incidencias/export', filters, {responseType: 'blob'}).then(res => res.data);
    },
    exportCulpaRecomotor: async (filters) => {
        return API.post('/incidencias/export-culpa-recomotor', filters, {responseType: 'blob'}).then(res => res.data);
    },
    updateIncidencia: async (incidenciaId, incidencia) => {
        return API.put('/incidencias/' + incidenciaId, incidencia).then(res => res.data);
    },
    deleteIncidencia: async (incidenciaId) => {
        return API.delete('/incidencias/' + incidenciaId).then(res => res.data);
    }
}

export const API_INCIDENCIA_STATUS_LOGS = {
    newStepsLogs: async (steps) => {
        return API.post('/incidencia_steps_logs', steps).then(res => res.data);
    }
}

export const API_VALES_DESCUENTOS = {
    newValeDescuento: async (valeDescuento) => {
        return API.post('/vales-descuentos', valeDescuento).then(res => res.data);
    },
    enviarValeDescuento: async (valeDescuentoId) => {
        return API.post('/vales-descuentos/' + valeDescuentoId + '/enviar', {}).then(res => res.data);
    },
    updateValeDescuento: async (valeDescuento) => {
        return API.put('/vales-descuentos/' + valeDescuento.id, valeDescuento).then(res => res.data);
    },
    deleteValeDescuento: async (valeDescuentoId) => {
        return API.delete('/vales-descuentos/' + valeDescuentoId).then(res => res.data);
    }
}